<template>
<div class="toggle-layout-wrapper">

  <p class="title">{{ title }}</p>

  <div class="toggle-layout">
    <div v-for="(state, index) in stateList" :key="index">

      <label :for="state"
             class="toggle-button"
             :class="{
                'active': inputValue === state,
                'left-radius': index === 0,
                'right-radius': index === stateList.length - 1,
                'pipe-button': index > 0 && index < stateList.length - 1,
              }">
        <p class="toggle-text">{{ state }}</p>
      </label>

      <input class="toggle-input"
             type="radio"
             :id="state"
             :name="state"
             :value="state"
             v-model="inputValue"
             @change="onChangeState"/>

      <div v-if="index > 0" class="vertical-line"></div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'LayoutToggle',
  props: {
    title: String,
    value: [String, Number, Boolean],
    stateList: Array,
    onChangeState: {
      type: Function,
      default: () => ({}),
    },
  },
  watch: {
    inputValue(value) {
      this.$emit('input', value);
    },
  },
  data() {
    return {
      id: null,
      inputValue: this.value || null,
    };
  },
  created() {
    this.id = this._uid; // eslint-disable-line
  },
};
</script>

<style lang="scss" scoped>
$layout-height: 32px;
$radius-value: 3px;

.toggle-layout-wrapper {
  display: inline-flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  justify-content: center;

  position: relative;

  margin: 0;
  padding: 0;

  .title {
    width: auto;

    margin: 0 8px 0 0;
    padding: 0;

    font-size: 12px;
    color: rgba(0, 0, 0, 0.4);
  }

  .toggle-layout {
    width: auto;

    display: flex;
    flex-direction: row;
    align-content: center;
    align-items: center;
    justify-content: center;

    .toggle-button {
      display: flex;
      justify-content: center;
      align-content: center;
      align-items: center;

      width: 60px;
      height: $layout-height;

      background-color: rgb(255, 255, 255);

      cursor: pointer;

      transition: background-color 0.2s ease-in-out;

      .toggle-text {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.6);
        text-align: center;

        transition: color 0.2s ease-in-out;
      }
    }

    .toggle-button:hover {

      .toggle-text {
        color: rgb(77, 148, 145);
      }
    }

    .active {
      background-color: rgb(77, 148, 145);

      .toggle-text {
        color: rgb(255, 255, 255);
      }
    }

    .toggle-input {
      display: none;
    }

    .vertical-line {
      position: absolute;
      top: 0;

      width: 1px;
      height: $layout-height;

      background-color: rgba(0, 0, 0, 0.08);

      margin: 0;
      padding: 0;
    }

    .left-radius {
      border-top-left-radius: $radius-value;
      border-bottom-left-radius: $radius-value;

      border-left: rgba(0, 0, 0, 0.08) solid 1px;
      border-top: rgba(0, 0, 0, 0.08) solid 1px;
      border-bottom: rgba(0, 0, 0, 0.08) solid 1px;
    }

    .pipe-button {
      border-top: rgba(0, 0, 0, 0.08) solid 1px;
      border-bottom: rgba(0, 0, 0, 0.08) solid 1px;
    }

    .right-radius {
      border-top-right-radius: $radius-value;
      border-bottom-right-radius: $radius-value;

      border-right: rgba(0, 0, 0, 0.08) solid 1px;
      border-top: rgba(0, 0, 0, 0.08) solid 1px;
      border-bottom: rgba(0, 0, 0, 0.08) solid 1px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/LayoutToggle.vue